import { Component, OnInit } from '@angular/core';
import { ProductAttachment, ProductDetail } from '../../../model/products.model';
import { ProductsService } from '../../../services/products.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-customer',
  templateUrl: './customer.component.html',
  styleUrls: ['./customer.component.scss']
})
export class CustomerComponent implements OnInit {
  listProductsOrder: ProductDetail[];

  constructor(private productsService: ProductsService,
              private router: Router) { }

  ngOnInit() {
    this.getProductOrder();
  }

  getProductOrder() {
    this.productsService.getProducts().subscribe((data: ProductDetail[]) => {
        this.listProductsOrder = data;
      });
  }

  openFullViewImage(image: ProductAttachment) {
    this.productsService.currentImage = image;
    this.router.navigate(['/view-full-image-360']);
  }
}
